import { SET_GLOBAL_LOADER } from './GlobalLoaderType';

const initialState = {};

const reducers = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_GLOBAL_LOADER:
            return {
                ...state,
                ...action.loader,
            }

        default:
            return state;
    }
}

export {
    reducers
}
